import { z } from 'zod';
import { CareDocumentOutcomeSchema } from './CareDocumentOutcomeSchema';

const ConcernOutcomeSchema = CareDocumentOutcomeSchema.extend({
  concern: z.string().optional(),
});

export const CareDocumentClinicalAndExperienceOutcomesSchema = z.object({
  mycawConcern1: ConcernOutcomeSchema,
  mycawConcern2: ConcernOutcomeSchema,
  overallWellbeing: CareDocumentOutcomeSchema,
  otherFactors: CareDocumentOutcomeSchema.optional(),
  mostImportantAspectOfSupport: CareDocumentOutcomeSchema.optional(),
  returnToWorkSelfEfficacy: CareDocumentOutcomeSchema,
  fatigue: CareDocumentOutcomeSchema,
});

export type CareDocumentClinicalAndExperienceOutcomes = z.infer<
  typeof CareDocumentClinicalAndExperienceOutcomesSchema
>;
